import Vue from 'vue';
import { Form, FormItem, Input, Select, Option, Button, ButtonGroup, Tabs, TabPane, Card, Tag, Progress, Dialog, Pagination, Checkbox, CheckboxGroup, Radio, RadioGroup, Dropdown, DropdownMenu, DropdownItem, DatePicker, Upload, Cascader, Table, TableColumn, Row, Col, Link, Loading, MessageBox, Message, Notification } from 'element-ui';
// 表单
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Cascader);
// 布局
Vue.use(Row);
Vue.use(Col);
Vue.use(Card);
Vue.use(Tag);
Vue.use(Progress);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Link);
// 导航 & 弹窗
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
// 表格
Vue.use(Table);
Vue.use(TableColumn);
// 全局方法
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
